/// <reference path="../../typings/browser.d.ts" />

namespace Application.Services {
    'use strict';

    import IDeviceAlarmConfig = Models.IDeviceAlarmConfig;
    import FlexEvent = Models.FlexEvent;
    import HalConverter = Models.HalConverter;
    import IPaginatedList = Models.IPaginatedList;
    import IHalList = Models.IHalList;
    import IAlarmLevel = Models.IAlarmLevel;
    // import DeviceParams = Application.Models.DeviceParams;

    export class AlarmsService {
        public static $name: string = "alarmsService";
        public static $inject: string[] = ["backendService", "$q"];

        private backendService: BackendService;
        private $q: ng.IQService;

        private backendBaseUrl: string = window.backendUrl;
        private eventsBackendUrl: string = this.backendBaseUrl + 'flexEvents';
        private deviceAlarmConfigBackendUrl: string = this.backendBaseUrl + 'flexcollector/deviceAlarmConfigs/';
        private alarmsCache: FlexEvent[] = [];

        constructor(backendService: BackendService,
                    $q: ng.IQService) {
            this.backendService = backendService;
            this.$q = $q;
        }

        public getAlarmConfigsByHref(href: string): ng.IPromise<IDeviceAlarmConfig[]> {
            href = Common.Utils.getSimplifiedHrefFromString(href);
            return this.backendService
                .get(this.deviceAlarmConfigBackendUrl + 'byHref' + href , false)
                .then((alarms: ng.IHttpPromiseCallbackArg<IDeviceAlarmConfig[]>) => {
                    return alarms.data.map((deviceAlarmConfig: IDeviceAlarmConfig) => {
                        return this.burnishLevels(deviceAlarmConfig);
                    });
                });
        }

        public getAlarmConfigsByHrefAndCondition(href: string, condition: string): ng.IPromise<IDeviceAlarmConfig> {
            href = Common.Utils.getSimplifiedHrefFromString(href);
            return this.backendService
                .get(this.deviceAlarmConfigBackendUrl + 'byHref' + href + "/" + condition, false)
                .then((alarms: ng.IHttpPromiseCallbackArg<IDeviceAlarmConfig>) => {
                    return this.burnishLevels(alarms.data);
                });
        }

        public saveAlarmConfigs(alarmConfig: IDeviceAlarmConfig): ng.IPromise<IDeviceAlarmConfig> {
            let unburnished: IDeviceAlarmConfig = this.unburnishLevels(alarmConfig);
            return this.backendService
                .put(this.deviceAlarmConfigBackendUrl + unburnished.id, unburnished)
                .then((alarms: ng.IHttpPromiseCallbackArg<IDeviceAlarmConfig>) => {
                    return this.burnishLevels(alarms.data);
                });
        }

        public applyTemplateToDevices(deviceAlarmConfig: IDeviceAlarmConfig, devicesHref: string[]): ng.IPromise<{}> {
            return this.backendService
                .put(this.deviceAlarmConfigBackendUrl + deviceAlarmConfig.id + '/applyTemplate', {
                    hrefs: devicesHref,
                });
        }

        public findEventsForStreamPipe(streamPipeId: number, startDate: Date, endDate: Date, toUTC?: boolean): 
            ng.IPromise<IPaginatedList<FlexEvent>> {
            let url: string = this.eventsBackendUrl + "/findAllFromStreamPipe/" + streamPipeId + "?" +
                'startDate=' + (toUTC ? Common.Utils.dateToString(startDate, undefined, true) : Common.Utils.dateToString(startDate)) +
                '&endDate=' + (toUTC ? Common.Utils.dateToString(endDate, undefined, true) : Common.Utils.dateToString(endDate));

            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList;
                });
        }

        public findEventsForEventBrowser(size: number, user: string, component: string,
                                         operation: string, startDate: Date, endDate: Date, page: number = 0, toUTC?: boolean):
                                         ng.IPromise<IPaginatedList<FlexEvent>> {

            let url: string = this.eventsBackendUrl + '/findAllCustomFilter?';

            if (size === undefined)
                size = 20;
            url += '&size=' + size;
            url += '&page=' + page;

            if (user !== undefined)
                url += '&userId=' + user;
            if (component !== undefined && operation !== undefined)
                url += '&component=' + component + '&operation=' + operation;
            if (startDate !== undefined)
                url += '&startDate=' + (toUTC ? Common.Utils.dateToString(startDate, undefined, true)
                     : Common.Utils.dateToString(startDate));
            if (endDate !== undefined)
                url += '&endDate=' + (toUTC ? Common.Utils.dateToString(endDate, undefined, true)
                     : Common.Utils.dateToString(endDate));

            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList;
                });
        }

        public findEventsForSonLinkId(id: number, startDate?: Date, endDate?: Date): ng.IPromise<FlexEvent[]> {
            endDate = endDate ? endDate : new Date();
            const now: Date = new Date();
            startDate = startDate ? startDate : new Date(now.setDate(now.getDate() - 7));

            const url: string = this.eventsBackendUrl + `/filtered/findAllFromSonLinkId?id=${id}` +
                                                                                      `&startDate=${Common.Utils.dateToString(startDate)}` +
                                                                                      `&endDate=${Common.Utils.dateToString(endDate)}`;
            return this.backendService.get(url).then((response: ng.IHttpPromiseCallbackArg<FlexEvent[]>) => {
                return response.data;
            });
        }

        public findEventsForHref(href: string, startDate?: Date, endDate?: Date): ng.IPromise<FlexEvent[]> {
            endDate = endDate ? endDate : new Date();
            const now: Date = new Date();
            startDate = startDate ? startDate : new Date(now.setDate(now.getDate() - 7));

            const url: string = this.eventsBackendUrl + `/filtered/findAllFromHref?href=${href}` +
                `&startDate=${Common.Utils.dateToString(startDate)}` +
                `&endDate=${Common.Utils.dateToString(endDate)}`;
            return this.backendService.get(url).then((response: ng.IHttpPromiseCallbackArg<FlexEvent[]>) => {
                return response.data;
            });
        }

        /**
         * 
         * @param portId format: {{switchId}}.{{port}}
         */
        public findEventsForDataPort(portId: string, startDate?: Date, endDate?: Date): ng.IPromise<FlexEvent[]> {
            endDate = endDate ? endDate : new Date();
            const now: Date = new Date();
            startDate = startDate ? startDate : new Date(now.setDate(now.getDate() - 7));

            const url: string = this.eventsBackendUrl + `/filtered/findAllFromDataPort?portId=${portId}` +
                                                                                      `&startDate=${Common.Utils.dateToString(startDate)}` +
                                                                                      `&endDate=${Common.Utils.dateToString(endDate)}`;
            return this.backendService.get(url).then((response: ng.IHttpPromiseCallbackArg<FlexEvent[]>) => {
                return response.data;
            });
        }

        public findAllAlarmsBySourceDestSimplifiedHrefAndInterval(sourceSimpHref: string, destSimpHref: string, 
                                                                  startDate: Date, endDate: Date, toUTC?: boolean): 
                                         ng.IPromise<IPaginatedList<FlexEvent>> {

            let url: string = this.eventsBackendUrl + '/findAllAlarmsBySourceDestSimplifiedHrefAndTimestampBetween?';

            if (sourceSimpHref !== undefined)
                url += '&sourceSimpHref=' + sourceSimpHref;

            if (destSimpHref !== undefined)
                url += '&destSimpHref=' + destSimpHref;

            if (startDate !== undefined)
                url += '&startDate=' + (toUTC ? Common.Utils.dateToString(startDate, undefined, true)
                     : Common.Utils.dateToString(startDate));
            if (endDate !== undefined)
                url += '&endDate=' + (toUTC ? Common.Utils.dateToString(endDate, undefined, true)
                     : Common.Utils.dateToString(endDate));

            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList;
                });
        }

        public findAllFromSourceNode(sourceId: number,
                                     startDate: Date,
                                     endDate: Date,
                                     toUTC?: boolean): ng.IPromise<IPaginatedList<FlexEvent>> {

            let url: string = this.eventsBackendUrl + '/findAllFromSourceNode/' + sourceId + "?";

            if (startDate !== undefined)
                url += '&startDate=' + (toUTC ? Common.Utils.dateToString(startDate, undefined, true)
                        : Common.Utils.dateToString(startDate));
            if (endDate !== undefined)
                url += '&endDate=' + (toUTC ? Common.Utils.dateToString(endDate, undefined, true)
                        : Common.Utils.dateToString(endDate));

            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList;
                });
        }

        public findAllFromBlockId(blockId: number,
                                  startDate: Date,
                                  endDate: Date,
                                  toUTC?: boolean): ng.IPromise<IPaginatedList<FlexEvent>> {

            let url: string = this.eventsBackendUrl + '/findAllFromBlockId/' + blockId + "?";

            if (startDate !== undefined)
                url += 'startDate=' + (toUTC ? Common.Utils.dateToString(startDate, undefined, true)
                    : Common.Utils.dateToString(startDate));
            if (endDate !== undefined)
                url += '&endDate=' + (toUTC ? Common.Utils.dateToString(endDate, undefined, true)
                    : Common.Utils.dateToString(endDate));

            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList;
                });
        }

        public findAllByType(alarmType: string, pageSize?: number, offset?: number, system: boolean = false,
                             deviceNames?: string, names?: string, values?: string, levels?: string, search?: string
                             ): ng.IPromise<IPaginatedList<FlexEvent>> {
            let alarmTypeInRequest = '';
            switch (alarmType) {
                case Directives.AlarmsDirective.ACTIVE:
                    alarmTypeInRequest = 'NotMasked';
                break;
                case Directives.AlarmsDirective.MASKED:
                    alarmTypeInRequest = 'Masked';
                break;
                case Directives.AlarmsDirective.ACK:
                    alarmTypeInRequest = 'Confirmed';
                break;
            }
            return this.findFlexEvents(this.eventsBackendUrl + `/filtered/findFlexAlarms${alarmTypeInRequest}`, pageSize, offset, system,
                deviceNames, names, values, levels, search);
        }

    public countCriticalFlexAlarms(isSystem?: boolean): ng.IPromise<Models.ICriticalCountResponse> {
        let systemString: string = isSystem ? `?system=${isSystem}` : '';
        let url: string = `${this.eventsBackendUrl}/filtered/countCriticalFlexAlarmsNotMasked${systemString}`;
        return this.backendService.get(url, false)
            .then((result: ng.IHttpPromiseCallbackArg<Models.ICriticalCountResponse>) => {
                return result.data;
            });
    }

        public getSeverityColor(severity: number): string {
            let severityColors: string[] = [
                '#ff001d', // red
                '#ff8e2e', // orange
                '#ffc439', // yellow-orange
                '#fefe47', // yellow
                '#bcff45', // green-yellow
                '#fefe47', // yellow
                '#ffc439', // yellow-orange
                '#ff8e2e', // orange
                '#ff001d', // red
            ];
            if (severity === undefined || severity > severityColors.length - 1)
                severity = severityColors.length - 1;
            else if (severity < 0)
                severity = 0;
            return severityColors[severity];
        }

        public getSeverityText(severity: number): string {
            let severityTexts: string[] = [
                'Critical low',
                'Major low',
                'Minor low',
                'Warning low',
                'Normal',
                'Warning high',
                'Minor high',
                'Major high',
                'Critical high',
            ];
            if (severity === undefined || severity > severityTexts.length - 1)
                severity = severityTexts.length - 1;
            else if (severity < 0)
                severity = 0;
            return severityTexts[severity];
        }

        /**
         * Mask a particular device+param+level for all conditions in the device.
         * @param {string} href
         * @param {string} paramName
         * @param {number} level
         * @param {boolean} masked
         * @param {boolean} showInfo
         * @returns {angular.IPromise<Application.Services.IDeviceAlarmConfig[]>}
         */
        public maskAlarmConfigLevel(href: string,
                                    paramName: string,
                                    level: number,
                                    masked: boolean,
                                    showInfo: boolean = false): ng.IPromise<IDeviceAlarmConfig[]> {
            return this.getAlarmConfigsByHref(href).then((alarmConfigAllConditions: Models.IDeviceAlarmConfig[]) => {
                let allPromises: ng.IPromise<IDeviceAlarmConfig>[] = alarmConfigAllConditions.map(
                    (deviceAlarmConfig: Models.IDeviceAlarmConfig) => {
                    let paramAlarmConfig: Models.IAlarmConfig;
                    [paramAlarmConfig] = deviceAlarmConfig.alarmConfigs.filter((alarmConfig: Models.IAlarmConfig) => {
                        return alarmConfig.paramName === paramName;
                    });
                    return this.maskAlarmConfigForParam(deviceAlarmConfig, paramAlarmConfig, level, masked, showInfo);
                });
                return this.$q.all(allPromises);

            });
        }

        public maskAlarmConfigParam(
                href: string, paramName: string, condition: string, masked: boolean): ng.IPromise<IDeviceAlarmConfig> {
            return this.getAlarmConfigsByHrefAndCondition(href, condition).then((alarmConfigs: Models.IDeviceAlarmConfig) => {
                let paramAlarmConfig: Models.IAlarmConfig;
                [paramAlarmConfig] = alarmConfigs.alarmConfigs.filter((alarmConfig: Models.IAlarmConfig) => {
                    return alarmConfig.paramName === paramName;
                });
                if (paramAlarmConfig) {
                    paramAlarmConfig.masked = masked;
                    return this.saveAlarmConfigs(alarmConfigs)
                        .then((alarmConfigsModified: IDeviceAlarmConfig) => {
                            return alarmConfigsModified;
                        });
                } else {
                    return undefined;
                }
            });
        }

        public maskAlarmConfigDevice(href: string, condition: string, mask: boolean): ng.IPromise<IDeviceAlarmConfig> {
            return this.getAlarmConfigsByHrefAndCondition(href, condition).then((alarmConfigs: IDeviceAlarmConfig) => {
                alarmConfigs.alarmConfigs.forEach((alarmConfig: Models.IAlarmConfig) => {
                    alarmConfig.masked = mask;
                });
                return this.saveAlarmConfigs(alarmConfigs)
                    .then((alarmConfigsModified: IDeviceAlarmConfig) => {
                        return alarmConfigsModified;
                    });
            });
        }

        public alarmsHaveBeenChanged(orig: Models.IAlarmConfig[], copy: Models.IAlarmConfig[]): boolean {
            for (let i: number = 0; i < orig.length; i++) {
                if (orig[i].stringComparison !== copy[i].stringComparison) return true;
                if (orig[i].enabled !== copy[i].enabled) return true;
                if (orig[i].masked !== copy[i].masked) return true;
                if (orig[i].hysteresis !== copy[i].hysteresis) return true;

                let exists: (element: any) => boolean = Common.Utils.exists; // tslint:disable-line
                for (let j: number = 0; j < orig[i].levels.length; j++) {
                    if (exists(orig[i].levels[j]) && exists(copy[i].levels[j])) {
                        if (orig[i].levels[j].masked !== copy[i].levels[j].masked) return true;
                        if (orig[i].levels[j].emailAlert !== copy[i].levels[j].emailAlert) return true;
                        if (exists(orig[i].levels[j].value) && exists(copy[i].levels[j].value)) {
                            if (orig[i].levels[j].value !== copy[i].levels[j].value) return true;
                        } else if (!exists(orig[i].levels[j].value) && exists(copy[i].levels[j].value) && copy[i].levels[j].value !== '') {
                            return true;
                        }
                    }
                }
            }
            return false;
        }

        public confirmEveryAlarm(comment: string, system: boolean): ng.IPromise<Models.IFlexEvent> {
            let url: string = this.eventsBackendUrl + "/bulkconfirm/all";
            return this.backendService.put(url, {
                comment: comment,
                system: system,
            }).then((result: ng.IHttpPromiseCallbackArg<Models.IFlexEvent>) => {
                return result.data;
            });
        }

        public confirmEveryAlarmForDevices(sourceSimpHref: string, destSimpHref: string, comment: string): ng.IPromise<Models.IFlexEvent> {
            let url: string = this.eventsBackendUrl + "/bulkconfirm?sourceSimpHref=" + sourceSimpHref +
                                                      "&destSimpHref=" + destSimpHref;
            return this.backendService.put(url, {
                comment: comment,
            }).then((result: ng.IHttpPromiseCallbackArg<Models.IFlexEvent>) => {
                return result.data;
            });
        }

        public confirmAlarm(eventId: number, comment: string): ng.IPromise<Models.IFlexEvent> {
            let url: string = this.eventsBackendUrl + "/confirm/" + eventId;
            return this.backendService.put(url, {
                comment: comment,
            }).then((result: ng.IHttpPromiseCallbackArg<Models.IFlexEvent>) => {
                return result.data;
            });
        }

        public validateAlarmConfigsValues(alarmConfig: IDeviceAlarmConfig): string[] {
            let errorsMap: string[] = [];
            if (alarmConfig) {
                for (let i: number = 0; i < alarmConfig.alarmConfigs.length; i++) {
                    // numeric params
                    if (alarmConfig.alarmConfigs[i].type === 'number') {
                        if (alarmConfig.alarmConfigs[i].levels.length > 0) {
                            let prev: number = parseFloat(alarmConfig.alarmConfigs[i].levels[0].value as string);
                            if (alarmConfig.alarmConfigs[i].levels[0].value !== undefined &&
                                alarmConfig.alarmConfigs[i].levels[0].value !== "" && isNaN(prev)) {
                                errorsMap[i] = alarmConfig.alarmConfigs[i].levels[0].value + ' is not a valid number.';
                            }
                            for (let j: number = 1; j < alarmConfig.alarmConfigs[i].levels.length; j++) {
                                if (Common.Utils.exists(alarmConfig.alarmConfigs[i].levels[j].value) &&
                                    alarmConfig.alarmConfigs[i].levels[j].value !== "") {
                                    let curr: number = parseFloat(alarmConfig.alarmConfigs[i].levels[j].value as string);
                                    if (!isNaN(prev) && !isNaN(curr) && curr <= prev) {
                                        errorsMap[i] = curr + ' is not greater than ' + prev + '.';
                                    } else if (!Common.Utils.isNumeric(alarmConfig.alarmConfigs[i].levels[j].value)) {
                                        errorsMap[i] = alarmConfig.alarmConfigs[i].levels[j].value + ' is not a valid number.';
                                    }
                                    prev = parseFloat(alarmConfig.alarmConfigs[i].levels[j].value as string);
                                }
                            }
                        }
                    // boolean params
                    } else if (alarmConfig.alarmConfigs[i].type === 'boolean') {
                        if (alarmConfig.alarmConfigs[i].levels.length > 0) {
                            let valuesCount: number = 0;
                            for (let j: number = 0; j < alarmConfig.alarmConfigs[i].levels.length; j++) {
                                let curr: string = alarmConfig.alarmConfigs[i].levels[j].value as string;
                                if (Common.Utils.exists(curr) && curr !== '') {
                                    if (curr !== 'true' && curr !== 'false')
                                        errorsMap[i] = `'${curr}' is not a boolean value. Only 'true' and 'false' values are allowed.`;
                                    else
                                        valuesCount++;
                                }
                            }
                            if (valuesCount > 2) errorsMap[i] = 'Only two values (true and false) can be defined for a boolean parameter.';
                        }
                    // string params
                    } else if (alarmConfig.alarmConfigs[i].type === 'string') {
                        // // no limits at the moment
                        // if (alarmConfig.alarmConfigs[i].levels.length > 0) {
                        // }
                    }
                }
            }
            return errorsMap.length > 0 ? errorsMap : undefined;
        }

        public findNotMaskedAlarmsFromSimplifiedHref(simplifiedHref: string): ng.IPromise<FlexEvent[]> {
            let hrefParam: string = Common.Utils.encodeQueryData({simplifiedHref: simplifiedHref});
            return this.backendService
                .get(this.eventsBackendUrl + '/search/findNotMaskedAlarmsFromSimplifiedHref?' + hrefParam)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    return convertedList.elements;
                });
        }

        public getAlarmsInfoFromSimplifiedHref(simplifiedHref: string): ng.IPromise<Models.IAlarmsInfo> {
            return this.backendService
                .get(this.eventsBackendUrl + '/getAlarmsInfoFromSimplifiedHref?href=' + simplifiedHref)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IAlarmsInfoHelper>) => {
                    return this.processAlarmResult(result.data);
                });
        }

        private processAlarmResult(alarmInfoHelper: Models.IAlarmsInfoHelper): Models.IAlarmsInfo {
            let alarmsInfo: Models.IAlarmsInfo = {
                currentAlarms: [],
                criticalNonHidden: alarmInfoHelper.criticalNonHidden,
                allNonHidden: alarmInfoHelper.allNonHidden,
            };
            for (let flexEvent of alarmInfoHelper.currentCriticalAlarms) {
                alarmsInfo.currentAlarms.push(flexEvent.data);
            }
            return alarmsInfo;
        }

        public getAlarmsInfoForListOfMonitorHrefs(monitorsHrefs: Models.IMonitorHrefs[]): ng.IPromise<Models.IAlarmsInfo[][]> {
            return this.backendService
                .post(this.eventsBackendUrl + '/getAlarmsInfoForListOfMonitorHrefs', monitorsHrefs)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IAlarmsInfoHelper[][]>) => {
                    return result.data.map((result1) => 
                        [].concat(...result1.map((alarmInfoHelper) => 
                            this.processAlarmResult(alarmInfoHelper)
                        ))
                    );
                });
        }

        public canReadEvent(flexEvent: Application.Models.IFlexEvent): ng.IPromise<boolean> {
            let url: string = this.eventsBackendUrl + "/canRead?flexEventId=" + flexEvent.id;
            return this.backendService.get(url, false, undefined, false, false)
                .then((response: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return response.data;
            });
        }

        public canWriteEventId(flexEventId: number): ng.IPromise<boolean> {
            let url: string = this.eventsBackendUrl + "/canWrite?flexEventId=" + flexEventId;
            return this.backendService.get(url, false, undefined, false, false)
                .then((response: ng.IHttpPromiseCallbackArg<boolean>) => {
                    return response.data;
                });
        }

        public findAlarmByHrefInCache(href: string): FlexEvent[] {
            return this.alarmsCache.filter((value: FlexEvent) => {
                    return value.data.deviceId === href;
                }).sort((a: FlexEvent, b: FlexEvent) => {
                    return 0 - (new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());
            });
        }


        public async getUniqueFields(field: string, system: boolean): Promise<string[]> {
            const url: string = `${this.eventsBackendUrl}/uniqueFieldValues?field=${field}&system=${system}`;
            return this.backendService.get(url)
                .then((res: ng.IHttpPromiseCallbackArg<string[]>) => {
                    return res.data;
            });
        }

        private maskAlarmConfigForParam(alarmConfig: Models.IDeviceAlarmConfig,
                                        paramAlarmConfig: Models.IAlarmConfig,
                                        level: number, masked: boolean, showInfo: boolean): ng.IPromise<IDeviceAlarmConfig> {
            if (paramAlarmConfig) {
                let paramAlarmConfigLevel: Models.IAlarmLevel;
                [paramAlarmConfigLevel] = paramAlarmConfig.levels.filter((alarmConfigLevel: Models.IAlarmLevel) => {
                    return alarmConfigLevel.numOrder === level;
                });
                if (paramAlarmConfigLevel) {
                    paramAlarmConfigLevel.masked = masked;
                    return this.saveAlarmConfigs(alarmConfig)
                        .then((alarmConfigsModified: IDeviceAlarmConfig) => {
                            let severityText: string = this.getSeverityText(level);
                            if (showInfo)
                                Common.Utils.alertOnInfo(`Param: '${paramAlarmConfig.paramName}' of level '` + severityText + `'
                                                          will be ${masked ? 'masked' : 'unmasked'}`);
                            return alarmConfigsModified;
                        });
                } else {
                    return undefined;
                }
            } else {
                return undefined;
            }
        }

        private findFlexEvents(url: string, pageSize?: number, offset?: number,
                               system: boolean = false,
                               deviceNames = '', names = '', values = '', levels = '', search = ''
                               ):  ng.IPromise<IPaginatedList<FlexEvent>> {
            //changed limit to size to do the pagination in back
            let queryString: string = '?size=' + pageSize + '&offset=' + offset + '&system=' + system.toString() +
                '&deviceNames=' + deviceNames + '&names=' + names + '&values=' + values + '&levels=' + levels +
                '&search=' + search;
            url = url + queryString;
            return this.backendService.get(url, false)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<FlexEvent>>) => {
                    let convertedList: Models.IPaginatedList<FlexEvent>;
                    convertedList = HalConverter.convertPaginatedList(result.data, FlexEvent.Empty);
                    convertedList.elements.map((fe: FlexEvent) => {
                        fe.data = Models.Alarm.burnish(fe.data);
                    });
                    this.alarmsCache = this.alarmsCache.concat(convertedList.elements);
                    return convertedList;
                });
        }

        private burnishLevels(alarms: IDeviceAlarmConfig): IDeviceAlarmConfig {
            if (alarms) {
                alarms.alarmConfigs.forEach((alarmConfig: Models.IAlarmConfig) => {
                    if (alarmConfig.paramName === 'bitrate'){
                        alarmConfig.unit = 'Mbit/sec';
                    }
                    let modifiedLevels: IAlarmLevel[] = new Array(9);
                    for (let i: number = 0; i < 9; i++) {
                        modifiedLevels[i] = {numOrder: i, masked: false, value: undefined,emailAlert:false};
                    }
                    alarmConfig.levels.forEach((level: Models.IAlarmLevel) => {
                        if (alarmConfig.paramName === 'bitrate' && level.value !== '' && level.value !== 0 && level.value !== undefined) {
                            level.value = +level.value / (1000 * 1000);
                        }
                        modifiedLevels[level.numOrder] = level;
                    });
                    alarmConfig.levels = modifiedLevels;

                    if (typeof alarmConfig.options !== 'undefined') {
                        alarmConfig.options.unshift({description: "", value: ""});
                    } else if (alarmConfig.type === 'boolean') {
                        alarmConfig.options =  [
                            {description: "", value: ""},
                            {description: "true", value: "true"},
                            {description: "false", value: "false"},
                        ];
                    }
                });
                return alarms;
            }
        }

        private unburnishLevels(alarms: IDeviceAlarmConfig): IDeviceAlarmConfig {
            if (alarms) {
                let copy: IDeviceAlarmConfig = Common.Utils.clone(alarms) as IDeviceAlarmConfig;
                copy.alarmConfigs.forEach((config: Models.IAlarmConfig) => {
                    for (let i: number = config.levels.length - 1; i >= 0; i--) {
                        if (config.paramName === 'bitrate') {
                            config.unit = 'bit/sec';
                            if (config.levels[i].value !== '' && config.levels[i].value !== undefined) {
                                config.levels[i].value = +config.levels[i].value * (1000 * 1000);
                            }
                        }
                        let val: Models.AlarmLevelValue = config.levels[i].value;
                        if ((!Common.Utils.exists(val) || val === '') && config.type !== "relay") {
                            config.levels.splice(i, 1);
                        }
                    }
                });
                return copy;
            }
        }

    }
}
